<div class="error-container">
  <div>
    <p class="numerror">500</p>
    <p class="titulo-error">Error interno del servidor</p>
    <p class="texto-error">
      Lo sentimos, parece que ha ocurrido un error al procesar su solicitud.
    </p>
    <br />
    <div class="btn-grupo">
      <button
        [routerLink]="['/']"
        class="btn"
        style="margin-left: -20px; margin-top: 30px"
      >
        Volver a inicio
      </button>
    </div>
  </div>
</div>
